import { WatchAccountService } from '../../../../services/watch-account.service';
import { Component } from '@angular/core';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalCreateCandidateComponent } from '../../../modals/create-candidate/modal-create-candidate.component';
import { ModalImportCandidatesComponent } from '../../../modals/import-candidates/modal-import-candidates.component';
import { PaginationTemplate } from '../../../../interfaces/pagination';
import {
  ICandidate,
  IAccount,
  IFunnel,
  ITag,
  IGroup,
} from '../../../../interfaces/graph-types';
import { AccountService } from '../../../../services/account.service';
import { Apollo, gql } from 'apollo-angular-boost';
import { ModalFunnelSelectorComponent } from '../../../modals/funnel-selector/modal-funnel-selector.component';
import { Observable, Subject, BehaviorSubject, Subscription } from 'rxjs';
import { CandidateService } from '../../../../services/candidate.service';
import { ModalConfirmComponent } from '../../../modals/confirm-delete-candidates/modal-confirm.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ModalTagsSelectorComponent } from '../../../modals/tags-selector/modal-tags-selector.component';
import { ModalEmailVerificationSelectorComponent } from '../../../modals/email-verification-selector/email-verification-selector.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: '[account-candidates-list]',
  template: require('./account-candidates-list.component.pug'),
  styles: [require('./account-candidates-list.component.css').toString()],
})
export class AccountCandidatesListComponent {
  bsModalRef: BsModalRef;
  subReason: Subscription;
  deleteCandidates$: Subscription;
  cancelCandidates$: Subscription;
  removeFromGroup$: Subscription;
  exportCandidates$: Subscription;
  dncCandidates$: Subscription;
  verifyEmailSub: Subscription;

  searchChanged: Subject<any> = new Subject<any>();

  candidatePagination: PaginationTemplate<ICandidate>;

  img_empty = require('./empty.png');

  private accountId$: Subscription;
  accountId: string;

  maxSize = 10;

  currentPage: number = 1;

  subjectCandidateIds: BehaviorSubject<string[]>;
  allPages = false;
  countSelected: BehaviorSubject<number>;
  countTotal: BehaviorSubject<number>;
  candidateSubjectId: Subject<string>;
  companySubjectId: Subject<string>;

  errorAddingToGroup: string = null;

  itemPerPage = 30;

  bulkActions: any = null;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private watch: WatchAccountService,
    private apollo: Apollo,
    private accountService: AccountService,
    private candidateService: CandidateService,
    private route: ActivatedRoute,
  ) {
    this.subjectCandidateIds = new BehaviorSubject<string[]>(null);
    this.countTotal = new BehaviorSubject<number>(0);
    this.countSelected = new BehaviorSubject<number>(0);
    this.candidateSubjectId = new Subject<string>();
    this.companySubjectId = new Subject<string>();

    this.bulkActions = [
      // { name: 'Start Funnel', trigger: this.addToFunnel.bind(this) },
      // {
      //   name: 'Verify email validity',
      //   trigger: this.initVerifyEmailsModal.bind(this),
      // },
      // {
      //   name: 'Cancel applications',
      //   trigger: this.initCancelCandidatesModal.bind(this),
      // },
      // {
      //   name: 'Remove from Group',
      //   trigger: this.initRemoveFromGroupModal.bind(this),
      // },
      // { name: 'Apply/Remove Tag', trigger: this.updateTag.bind(this) },
      // {
      //   name: 'Mark as DoNotContact',
      //   trigger: this.doNotContactModal.bind(this),
      // },
      { name: 'Delete', trigger: this.initDeleteCandidateModal.bind(this) },
      // {
      //   name: 'Email me as CSV',
      //   trigger: this.initExportToCSVModal.bind(this),
      // },
    ];
  }

  // -------------------------------------------------------------------
  buildQuery() {
    return this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query accountCandidatePagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $funnelId: Int
          $skip: Int
          $accountId: ID!
          $searchFilter: String
        ) {
          account(accountId: $accountId) {
            id
            candidates(
              first: $first
              last: $last
              after: $after
              before: $before
              funnelId: $funnelId
              skip: $skip
              searchFilter: $searchFilter
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  name
                  email
                  firstName
                  lastName
                  avatarUrl
                  lastFunnel {
                    name
                  }
                  mxProvider
                  updatedAt
                  group {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: false,
    });
  }

  // -------------------------------------------------------------------
  emptySearchFilter(): any {
    return {
      include_tags: [],
      exclude_tags: [],
      include_labels: [],
      exclude_labels: [],
      include_groups: [],
      exclude_groups: [],
      include_funnels: [],
      exclude_funnels: [],
      min_opens: null,
      max_opens: null,
      min_clicks: null,
      max_clicks: null,
      min_replies: null,
      max_replies: null,
      min_step: null,
      max_step: null,
      next_step_before: null,
      next_step_after: null,
      started_before: null,
      started_after: null,
      in_funnel: null,
      application_stage: null,
      application_status: [],
      do_not_contact: null,
      application_error: null,
      not_in_group: null,
      email_status: [],
      min_funnels: null,
      max_funnels: null,
      created_before: null,
      created_after: null,
    };
  }
  searchFilter: any = this.emptySearchFilter();

  // -------------------------------------------------------------------
  ngOnInit() {
    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));

    const query = this.buildQuery();

    this.accountId$ = this.watch.accountId().subscribe(accountId => {
      this.accountId = accountId;

      this.candidatePagination = new PaginationTemplate<ICandidate>(
        this.apollo,
        this.accountId,
        query,
        'account',
        'candidates',
        null,
        null,
        this.searchFilter,
        () => {
          this.countTotal.next(this.candidatePagination.totalCount);
        },
      );
    });
  }

  // -------------------------------------------------------------------
  ngAfterViewInit() {
    let candidateId = this.route.snapshot.queryParams['candidate_id'];
    if (candidateId) {
      this.selectCandidateInfo(candidateId);
    }
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.accountId$) {
      this.accountId$.unsubscribe();
    }
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
    if (this.deleteCandidates$) {
      this.deleteCandidates$.unsubscribe();
    }
    if (this.cancelCandidates$) {
      this.cancelCandidates$.unsubscribe();
    }
    if (this.dncCandidates$) {
      this.dncCandidates$.unsubscribe();
    }
    if (this.verifyEmailSub) {
      this.verifyEmailSub.unsubscribe();
    }
    if (this.removeFromGroup$) {
      this.removeFromGroup$.unsubscribe();
    }
    if (this.exportCandidates$) this.exportCandidates$.unsubscribe();
  }

  // -------------------------------------------------------------------
  isLoading() {
    return this.candidatePagination.isLoading();
  }

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.searchChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.textSearch = newvalue;
    this.candidatePagination.searchFilter.text = newvalue;

    this.candidatePagination.setOffset(0, () => {
      this.clearSelection();
    });
  }

  // -------------------------------------------------------------------
  backgroundImg() {
    /*
    if (!this.candidatePagination.items) {
      return 'url(' + this.img_empty + ')';
    }

    if (this.candidatePagination.items.length == 0) {
      return 'url(' + this.img_empty + ')';
    }
    */
    return 'none';
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watch.accountId().getValue();
  }

  textSearch: string = '';
  // -------------------------------------------------------------------
  onClickFilter(filter = this.emptySearchFilter()) {
    // TODO SEARCH WITH FILTER INPUT

    filter.text = this.textSearch;
    this.searchFilter = filter;
    this.candidatePagination.searchFilter = this.searchFilter;

    this.candidatePagination.refresh();
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(candidateId) {
    this.viewingCandidate = candidateId;
    this.candidateSubjectId.next(candidateId);
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  // -------------------------------------------------------------------
  hideAvatar(company) {
    company.avatarUrl = null;
  }

  viewingCompany: string;
  // -------------------------------------------------------------------
  selectCompanyInfo(company) {
    this.viewingCompany = company.id;
    this.companySubjectId.next(company.id);
  }

  // -------------------------------------------------------------------
  closeCompanyInfo() {
    this.viewingCompany = null;
  }

  // -------------------------------------------------------------------
  refresh() {
    this.candidatePagination.refresh();
  }

  // -------------------------------------------------------------------
  OpenCandidateModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      org_id: 0, //response.organization.id,
    };

    this.bsModalRef = this.modalService.show(
      ModalCreateCandidateComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      this.candidatePagination.refresh();
      this.clearSelection();
      this.selectCandidateInfo(res);
    });
  }

  // -------------------------------------------------------------------
  OpenImportCandidatesModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      account_id: this.watch.accountId().getValue(),
    };

    this.bsModalRef = this.modalService.show(
      ModalImportCandidatesComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  onFunnelSelected(
    funnelId: string,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    if (this.allPages) {
      this.accountService.bulkCandidatesToFunnel(
        funnelId,
        this.candidatePagination.searchFilter,
        res => {
          this.bsModalRef.hide();
          this.clearSelection();
        },
        error => {
          onfailure(error);
        },
      );
      return;
    }

    this.accountService.addCandidatesToFunnel(
      funnelId,
      this.subjectCandidateIds.getValue(),
      null,
      res => {
        this.bsModalRef.hide();
        this.clearSelection();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  onGroupSelected(
    groupId: string,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    if (this.allPages) {
      this.accountService.bulkAssignCandidatesToGroup(
        this.accountId,
        groupId,
        this.candidatePagination.searchFilter,
        res => {
          this.bsModalRef.hide();
          this.clearSelection();
        },
        error => {
          onfailure(error);
        },
      );
      return;
    }

    this.accountService.assignCandidatesToGroup(
      groupId,
      this.subjectCandidateIds.getValue(),
      null,
      res => {
        this.bsModalRef.hide();
        this.clearSelection();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  updateTag() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.accountId,
      onSelect: this.onTagsSelected.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalTagsSelectorComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  onTagsSelected(
    addTagIds: string[],
    removeTagIds: string[],
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    if (this.allPages) {
      this.candidateService.bulkApplyTagsToCandidates(
        this.watch.accountId().getValue(),
        addTagIds,
        removeTagIds,
        this.candidatePagination.searchFilter,
        res => {
          this.bsModalRef.hide();
          this.clearSelection();
        },
        error => {
          onfailure(error);
        },
      );
      return;
    }

    this.candidateService.applyTagsToCandidates(
      this.watch.accountId().getValue(),
      addTagIds,
      removeTagIds,
      this.subjectCandidateIds.getValue(),
      res => {
        this.bsModalRef.hide();
        this.clearSelection();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  addToFunnel() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.accountId,
      onSelect: this.onFunnelSelected.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalFunnelSelectorComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  initExportToCSVModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.ExportToCSV.bind(this),
      title: 'Confirm export to CSV',
      bodyText:
        "Initiate an Export, you'll get emailed with a downloadable link when completed",
      confirmText: '',
      buttonTitle: 'Launch Export',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);
    this.exportCandidates$ = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //-------------------------------------------------------------------
  ExportToCSV(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkExportCandidates(
        this.accountId,
        this.searchFilter,
        () => {
          this.handleListUpdate();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.ExportCandidates(
      this.accountId,
      this.subjectCandidateIds.getValue(),
      () => {
        this.handleListUpdate();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => onFailure(error),
    );
  }

  // -------------------------------------------------------------------
  initRemoveFromGroupModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.removeFromGroups.bind(this),
      title: 'Confirm removal from group',
      buttonTitle: 'Remove',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);
    this.removeFromGroup$ = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //-------------------------------------------------------------------
  removeFromGroups(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkAssignCandidatesToGroup(
        this.accountId,
        null,
        this.searchFilter,
        () => {
          this.handleListUpdate();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.assignCandidatesToGroup(
      this.subjectCandidateIds.getValue(),
      null,
      () => {
        this.handleListUpdate();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => onFailure(error),
    );
  }

  // -------------------------------------------------------------------
  doNotContactModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.doNotContactCandidates.bind(this),
      title: 'Confirm setting candidates as Do Not Contact',
      buttonTitle: 'Mark as Do Not Contact',
      confirmText: '',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);
    this.dncCandidates$ = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //-------------------------------------------------------------------
  doNotContactCandidates(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkDoNotContactCandidates(
        this.accountId,
        true,
        this.searchFilter,
        () => {
          this.handleListUpdate();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.doNotContactCandidates(
      this.subjectCandidateIds.getValue(),
      true,
      () => {
        this.handleListUpdate();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => onFailure(error),
    );
  }

  // -------------------------------------------------------------------
  initVerifyEmailsModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      accountId: this.accountId,
      onSelect: this.verifyEmails.bind(this),
    };

    this.bsModalRef = this.modalService.show(
      ModalEmailVerificationSelectorComponent,
      options,
    );
    this.verifyEmailSub = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });

    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //-------------------------------------------------------------------
  verifyEmails(
    selectedAddon: string,
    onSuccess: onSmartSuccess,
    onFailure: onSmartFailure,
  ) {
    if (this.allPages) {
      this.accountService.bulkVerifyEmails(
        this.accountId,
        selectedAddon,
        this.searchFilter,
        () => {
          // this.handleListUpdate();
          // this.clearSelection();
          //this.bsModalRef.hide();
          onSuccess();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.verifyEmails(
      this.subjectCandidateIds.getValue(),
      selectedAddon,
      () => {
        // this.handleListUpdate();
        // this.clearSelection();
        //this.bsModalRef.hide();
        onSuccess();
      },
      error => onFailure(error),
    );
  }

  //-------------------------------------------------------------------
  cancelCandidates(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkCancelCandidates(
        this.accountId,
        this.searchFilter,
        () => {
          this.handleListUpdate();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.cancelCandidates(
      this.accountId,
      this.subjectCandidateIds.getValue(),
      () => {
        this.handleListUpdate();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => onFailure(error),
    );
  }

  //-------------------------------------------------------------------
  initCancelCandidatesModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.cancelCandidates.bind(this),
      title: 'Confirm cancelling all applications of candidates',
      bodyText: 'Candidates will have all their applications cancelled.',
      buttonTitle: 'Cancel Applications',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);
    this.deleteCandidates$ = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //-------------------------------------------------------------------
  deleteCandidates(onFailure: onSmartFailure) {
    if (this.allPages) {
      this.accountService.bulkDeleteCandidates(
        this.accountId,
        this.searchFilter,
        () => {
          this.handleListUpdate();
          this.clearSelection();
          this.bsModalRef.hide();
        },
        error => onFailure(error),
      );
      return;
    }

    this.candidateService.deleteCandidates(
      this.subjectCandidateIds.getValue(),
      () => {
        this.handleListUpdate();
        this.clearSelection();
        this.bsModalRef.hide();
      },
      error => onFailure(error),
    );
  }

  // -------------------------------------------------------------------
  initDeleteCandidateModal() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      onDelete: this.deleteCandidates.bind(this),
      title: 'Confirm deletion of candidates',
    };

    this.bsModalRef = this.modalService.show(ModalConfirmComponent, options);
    this.deleteCandidates$ = this.bsModalRef.content.reason.subscribe(() => {
      this.handleListUpdate();
      this.clearSelection();
    });
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  handleListUpdate() {
    this.candidatePagination.refresh();
  }

  // -------------------------------------------------------------------
  setPage(newPage: number) {
    this.currentPage = newPage;
    this.candidatePagination.setOffset((newPage - 1) * this.itemPerPage);
  }

  // -------------------------------------------------------------------
  toggleCandidateSelection(candidateId: string) {
    let all = this.subjectCandidateIds.getValue();

    if (!all) {
      all = [];
    }

    var index = all.indexOf(candidateId);
    if (index == -1) {
      // not found, we add it
      all.push(candidateId);
    } else {
      all.splice(index, 1);
    }
    this.subjectCandidateIds.next(all);
    this.allPages = false;
    this.countSelected.next(all.length); //this.candidatePagination.items.length);
  }

  // -------------------------------------------------------------------
  toggleGlobal() {
    if (
      this.countSelected.getValue() != this.candidatePagination.items.length
    ) {
      this.selectOnePage();
    } else {
      this.clearSelection();
    }
  }

  // -------------------------------------------------------------------
  selectOnePage() {
    let selected = [];
    this.candidatePagination.items.forEach((candidate: any) => {
      selected.push(candidate.id);
    });
    this.countSelected.next(selected.length); //this.candidatePagination.items.length);
    this.subjectCandidateIds.next(selected);
    this.allPages = false;
  }

  // -------------------------------------------------------------------
  selectAllPages() {
    this.candidatePagination.items.forEach((candidate: any) => {
      candidate.selected = true;
    });
    this.countSelected.next(this.candidatePagination.totalCount);
    this.subjectCandidateIds.next(null);
    this.allPages = true;
  }

  // -------------------------------------------------------------------
  isCandidateSelected(candidateId) {
    if (this.allPages) {
      return true;
    }

    let all = this.subjectCandidateIds.getValue();
    if (!all) {
      return false;
    }

    return all.indexOf(candidateId) >= 0;
  }

  // -------------------------------------------------------------------
  clearSelection() {
    this.countSelected.next(null);
    this.subjectCandidateIds.next(null);
    this.allPages = false;
  }

  // -------------------------------------------------------------------
  updateField(params) {
    this.candidateService.setField(
      params.id,
      params.field,
      params.value,
      () => {
        params.onCompletion(null);
      },
      error => {
        params.onCompletion(error);
      },
    );
  }
}
